// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__bj5CB","affixWrapper":"styles_affixWrapper__ie3_W","wrapperInput":"styles_wrapperInput__F1xb9"};